import React, { useContext } from 'react';
import {
  Grid,
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography
} from '@material-ui/core';
import { I18nContext } from 'translations';
import DriverReserved from 'components/Cards/DriverReserved';

export default function ModalServiceDriver ({
  open,
  setOpen,
  listReservations,
  bookingReservationId,
  selectedPrincipalBooking,
  setOpenModalServiceDriver
}) {
  const { translate } = useContext(I18nContext);

  return (
    <Dialog
      open={open}
      aria-describedby="alert-dialog-description"
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle disableTypography style={{ padding: '20px' }}>
        <Typography variant="subtitle1" style={{ marginBottom: 10 }}>
          {translate('app.bookingReserved.selectDriverForHours')}
        </Typography>
        <Typography variant="body2">
          {translate('app.bookingReserved.description')}
        </Typography>
      </DialogTitle>

      <DialogContent className="text-center" style={{ padding: '0px 24px 8px' }}>
        <Grid container spacing={2}>
          {listReservations?.length > 0 && listReservations.map((item) => (
            <Grid item xs={12} sm={12} md={6} key={item._id}>
              <DriverReserved
                selectedPrincipalBooking={selectedPrincipalBooking}
                data={item}
                bookingReservationId={bookingReservationId}
                setOpenModalServiceDriver={setOpenModalServiceDriver}
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenModalServiceDriver(null)}>
          {translate('close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}